import {
  VxlSystemBanner,
  VxlSystemBannerType,
} from '@varo/graphql-schema-types';
import { HomeCardDependencies } from 'features/home/HomeScreen/dependencies/types';
import {
  SystemBannerProps,
  SystemBannerType,
} from 'shared/components/vxl/SystemBanner/SystemBanner.types';

const getBannerType = (type: VxlSystemBannerType): SystemBannerType => {
  switch (type) {
    case VxlSystemBannerType.Info:
      return SystemBannerType.INFO;
    case VxlSystemBannerType.Success:
      return SystemBannerType.SUCCESS;
    case VxlSystemBannerType.Warning:
      return SystemBannerType.WARNING;
    case VxlSystemBannerType.Error:
      return SystemBannerType.ERROR;
    case VxlSystemBannerType.Brand:
      return SystemBannerType.BRAND;
  }
};

const mapSystemBanners = (
  banners: VxlSystemBanner[],
  dependencies: HomeCardDependencies,
): SystemBannerProps[] => {
  const { bannerCardDismissClicked, navigateToRoute } = dependencies;

  return banners.map((item) => {
    const buttonProps = item.buttonTitle
      ? {
          label: item.buttonTitle,
          onPress: () => {
            if (item.bannerNavigation) {
              navigateToRoute(item.bannerNavigation);
            }
          },
        }
      : undefined;

    return {
      iconKeyType: item.iconV2 ?? undefined,
      titleText: item.title,
      bodyText: item.body ?? undefined,
      bannerType: getBannerType(item.type),
      customAttributes: { alert_name: item.alertName ?? '' },
      onDismiss: item.dismissId
        ? () => {
            bannerCardDismissClicked(item.dismissId as string);
          }
        : undefined,
      onCardPress: item.bannerNavigation
        ? () => {
            if (item.bannerNavigation) {
              navigateToRoute(item.bannerNavigation);
            }
          }
        : undefined,
      button: buttonProps,
    };
  });
};

export default mapSystemBanners;
